import React from 'react';
import { BoxIcon } from 'lucide-react';
type EmptyStateProps = {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
  illustration?: string;
};
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  illustration
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-16 px-4 text-center" data-id="element-677">
      {illustration ? <div className="mb-6" data-id="element-678">
          <img src={illustration} alt={title} className="w-48 h-48 object-contain opacity-80" data-id="element-679" />
        </div> : <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center mb-6 shadow-inner" data-id="element-680">
          <Icon className="w-10 h-10 text-gray-400" data-id="element-681" />
        </div>}

      <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-682">{title}</h3>
      <p className="text-gray-600 mb-8 max-w-md leading-relaxed" data-id="element-683">
        {description}
      </p>

      <div className="flex flex-col sm:flex-row gap-3" data-id="element-684">
        {actionLabel && onAction && <button onClick={onAction} className="px-8 py-3 bg-[#4ade80] text-white font-semibold rounded-xl hover:bg-[#22c55e] transition-all hover:shadow-lg hover:-translate-y-0.5" data-id="element-685">
            {actionLabel}
          </button>}
        {secondaryActionLabel && onSecondaryAction && <button onClick={onSecondaryAction} className="px-8 py-3 bg-white text-gray-700 font-semibold rounded-xl border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all" data-id="element-686">
            {secondaryActionLabel}
          </button>}
      </div>
    </div>;
}